import { render, staticRenderFns } from "./StockingUnitSelector.vue?vue&type=template&id=01de6aee&scoped=true"
import script from "./StockingUnitSelector.vue?vue&type=script&lang=js"
export * from "./StockingUnitSelector.vue?vue&type=script&lang=js"
import style0 from "./StockingUnitSelector.vue?vue&type=style&index=0&id=01de6aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01de6aee",
  null
  
)

export default component.exports